import { resolveClientPage } from "@picovico/utils";

// a name based route map for the web app
const pageRoutes = Object.freeze({
  config: "/config",
  movie_detail: "/movie/:movieIdx/:cinemaHallIdx",
  audi_detail: "/movie/:movieIdx/booking/:showIdx",
  login: "/login",
  register: "/register",
  forgot_password: "/forgot-password",
  reset_password: "/auth/reset-password",
  confirm_booking: "/movie/:movieIdx/booking/:showIdx/confirm",
  food_booking: "/movie/:movieIdx/booking/:showIdx/food",
  payment_callback: "/payment/callback",
  profile_edit: "/profile/edit",
  profile: "/profile",
  "payment-error": "/payment-error",
  booking_confirmation: "/movie/:movieIdx/booking/:showIdx/confirm",
  advertisement_detail: "/advertisement/:advertisementIdx",
  home: "/",
  booking: '/booking',
  food_order: '/food/:orderIdx',
  food: '/food'
});

export const getPageRoutes = resolveClientPage(pageRoutes);

export default pageRoutes;
